import styled from 'styled-components';
import { breakpoints } from '../../styles/breakpoints';

export const ContentInfoWrapper = styled.div`
	@media ${breakpoints.sm} {
		max-width: 800px;
	}
`;
